import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { WhatsAppFloat } from '../ui/whatsapp-float';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};